import { ModalHeader as Header } from "@ondit/ui";
import type { ComponentProps } from "react";
import { useT } from "~/core/i18n";

/**
 * The modal header, with the close mark named in the reader's language.
 *
 * Not a second modal: `@ondit/ui` owns every part of one. This binds the single
 * string the library cannot know, because the library sits below both
 * catalogues and the panel's is keyed rather than English-indexed.
 */
export function ModalHeader(props: Omit<ComponentProps<typeof Header>, "closeLabel">) {
	const t = useT();
	return <Header closeLabel={t("common.close")} {...props} />;
}
